// extracted by mini-css-extract-plugin
export default {"font-renta":"HoursAndDistances_font-renta__pBgZl","workOrderJobSummary":"HoursAndDistances_workOrderJobSummary__ZaDtJ"};